import gql from 'graphql-tag';

export const DEAL_ACTIVITY_FRAGMENT = gql`
  fragment DealEventActivityFields on DealEventActivityViewModel {
    id
    type
    parentId
    directionType
    activityStatus
    createdDateTime
    updatedDateTime

    endAt
    allDay
    subject
    startAt
    endDate
    eventType
    startDate
    accountId
    description

    account {
      id
      name
      portalType
    }

    due {
      dueAt
      isOverdue
      secondsSinceDue
      secondsUntilDue
    }

    participants {
      id
      fullName
      participationType
    }

    priority
    completedAt
    isCompleted
  }
`;
